import React from 'react';
import wenhaoPng from '@/static/images/wenhao.png';

interface props {
  name: string;
}

const NoData: React.FC<props> = (props) => {
  return (
    <div className="flex_4_1" style={{ padding: '60px 0 100px' }}>
      <img src={wenhaoPng} width={200} height={200} />
      <div className="col808">{props.name}</div>
    </div>
  );
};

export default NoData;
